var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleform = function SvgSimpleform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56 28c0 15.464-12.536 28-28 28S0 43.464 0 28 12.536 0 28 0s28 12.536 28 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37517E",
    d: "M14.676 10.117c0-.8.644-1.446 1.458-1.446h23.732a1.45 1.45 0 0 1 1.458 1.446v35.769c0 .797-.65 1.443-1.458 1.443H16.134a1.445 1.445 0 0 1-1.458-1.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B9FF",
    d: "M26.529 45.712a.644.644 0 0 1-.643-.646v-.155c0-.363.296-.642.643-.642h2.94c.347 0 .645.28.645.642v.155a.647.647 0 0 1-.645.646zM27.997 11.223a.663.663 0 0 1-.666-.665c0-.369.294-.668.666-.668.37 0 .671.3.671.668a.67.67 0 0 1-.67.665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    d: "M28 10.832a.27.27 0 0 1-.27-.274c0-.153.117-.274.27-.274a.27.27 0 0 1 .271.274.27.27 0 0 1-.272.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FB",
    d: "M16.185 42.65h23.626V12.446H16.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M17.919 17.758h9.244v-3.582h-9.244zM28.831 17.758h9.247v-3.582h-9.247zM17.919 38.344h20.16v-1.18h-20.16zM17.919 40.921h20.16v-1.18h-20.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B9FF",
    d: "M17.919 35.765h9.244v-8.647h-9.244zM28.831 35.765h9.247v-8.647h-9.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M17.919 25.723h20.16v-6.566h-20.16z"
  }))));
};
export default SvgSimpleform;